(ns dashboard.components.tooltip
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.utils :refer [cs href]]
   [headlessui-reagent.core :as ui]))

(defn tooltip [& children]
  `[:div.px-3.py-2.shadow-lg.bg-white.focus:outline-none.text-left.min-w-min.absolute.hidden.z-50.invisible.opacity-0.group-hover:block.group-hover:visible.group-hover:opacity-100.group-focus:block.group-focus:visible.group-focus:opacity-100.delay-200.ease-in-out.w-80.rounded
   {:class "top-full left-1/2 transform -translate-x-1/3 translate-y-1"
    :role "tooltip"}
    ~@children])
